import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "all",
  "use": "all-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"all\">\n<rect x=\"12.5\" y=\"12.5\" width=\"10\" height=\"10\" rx=\"2\" />\n<rect x=\"12.5\" y=\"1.5\" width=\"10\" height=\"10\" rx=\"2\" fill=\"#979797\" />\n<rect x=\"1.5\" y=\"12.5\" width=\"10\" height=\"10\" rx=\"2\" />\n<rect x=\"1.5\" y=\"1.5\" width=\"10\" height=\"10\" rx=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol